import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.search.js";
export default {
  props: {
    to: {
      type: [String, Object],
      default: ''
    },
    'activate-class': {
      type: [String],
      default: ''
    },
    isHint: {
      type: Boolean,
      default: false
    },
    open: {
      type: Boolean,
      default: false
    },
    targetType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      href: '',
      target: '',
      activate: false
    };
  },
  watch: {
    $route: function $route() {
      this.isAct();
    },
    to: {
      handler: function handler() {
        this.setUrl();
      }
    }
  },
  computed: {},
  created: function created() {
    this.setUrl();
  },
  mounted: function mounted() {
    this.isAct();
  },
  methods: {
    setUrl: function setUrl() {
      if (this.to) {
        var to = this.to;
        if (typeof to == 'string') {
          this.href = to;
        } else {
          if (Object.keys(to).length) {
            if (!to.query) {
              to.query = {};
            }
            if (to.params) {
              if (to.type == 'article') {
                to.path = '/news/' + to.params.id;
              } else if (to.type == 'activity') {
                to.path = '/activity/' + to.params.id;
              } else if (to.params.url) {
                to.path = to.params.url;
              } else {
                Object.assign(to.query, to.params);
              }
            }
            to.name = '';
            var route = this.$router.match(to);
            this.href = route.fullPath;
          } else {
            this.href = 'javascript:;';
          }
        }
        if (this.href.indexOf('http') != -1 || this.href.indexOf('https') != -1) {
          this.target = '_blank';
          if (this.href.charAt(0) == '/') {
            this.href = this.href.slice(1);
          }
        } else {
          this.target = '_self';
          if (this.href != 'javascript:;' && this.href.charAt(0) != '/') {
            this.href = '/' + this.href;
          }
        }
      } else {
        this.href = 'javascript:;';
      }
      if (this.targetType) {
        this.target = this.targetType;
      }
    },
    onClick: function onClick() {
      if (this.open) {
        this.target = '_blank';
      }
      if (this.href != 'javascript:;') {
        if (this.target == '_self') {
          this.$router.push(this.href);
        } else {
          if (this.isHint) {
            if (this.href.indexOf(window.location.origin) == -1) {
              window.open(window.location.origin + "/link?target=".concat(this.href));
            } else {
              window.open(this.href);
            }
          } else {
            window.open(this.href);
          }
        }
      }
    },
    isAct: function isAct() {
      var _this = this;
      this.$nextTick(function () {
        var url = window.location.pathname + window.location.search;
        if (_this.href.indexOf('http') == -1 || _this.href.indexOf('https') == -1) {
          var href = _this.$router.match(_this.href);
          if (href.fullPath == url) {
            _this.activate = true;
            _this.$emit('activate');
          } else {
            _this.activate = false;
          }
        }
      });
    }
  }
};